import { wasmModule } from "../wasm/wasmModule"

class DeformModel {
  wasmdeformModule = null
  SwitchMeshDeformModule(num: boolean) {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.moduleManager.SwitchMeshDeformModule(num)
  }
  StartSelectCells() {
    if (!wasmModule.isFinishedOpencase) return
    this.wasmdeformModule = wasmModule.moduleManager.GetMeshDeformModule()
    if (this.wasmdeformModule != null)
      this.wasmdeformModule.StartSelectCells(true)
  }

  CloseSelectCells() {
    if (!wasmModule.isFinishedOpencase) return
    this.wasmdeformModule = wasmModule.moduleManager.GetMeshDeformModule()
    if (this.wasmdeformModule != null) {
      this.wasmdeformModule.CancelSelected()
      this.wasmdeformModule.GoToNormalState()
    }
  }

  StartDeform(inout: boolean) {
    if (!wasmModule.isFinishedOpencase) return
    this.wasmdeformModule = wasmModule.moduleManager.GetMeshDeformModule()
    if (this.wasmdeformModule != null) {
      this.wasmdeformModule.StartDeform(inout, true)
    }
  }

  StartSmoothMesh(num: number, clicked: boolean) {
    if (!wasmModule.isFinishedOpencase) return
    this.wasmdeformModule = wasmModule.moduleManager.GetMeshDeformModule()
    if (this.wasmdeformModule != null) {
      this.wasmdeformModule.StartSmoothMesh(num, clicked)
    }
  }
  Reset() {
    if (!wasmModule.isFinishedOpencase) return
    this.wasmdeformModule = wasmModule.moduleManager.GetMeshDeformModule()
    if (this.wasmdeformModule != null) {
      this.wasmdeformModule.Reset()
    }
  }
  FillTooth() {
    if (!wasmModule.isFinishedOpencase) return
    this.wasmdeformModule = wasmModule.moduleManager.GetMeshDeformModule()
    if (this.wasmdeformModule != null) {
      this.wasmdeformModule.CutAndFill()
    }
  }
  BackOneStep() {
    if (!wasmModule.isFinishedOpencase) return
    this.wasmdeformModule = wasmModule.moduleManager.GetMeshDeformModule()
    if (this.wasmdeformModule != null) {
      this.wasmdeformModule.BackOneStep()
    }
  }
  SetUpdate2DButtonsPosJsCallBack(callback: (x: number, y: number) => void) {
    if (!wasmModule.isFinishedOpencase) return
    this.wasmdeformModule = wasmModule.moduleManager.GetMeshDeformModule()

    if (!(window as any).moduleMeshDeform) {
      ;(window as any).moduleMeshDeform = {}
    }
    ;(window as any).moduleMeshDeform.SetUpdate2DButtonsPosJsCallBack = callback
    if (this.wasmdeformModule != null) {
      this.wasmdeformModule.SetUpdate2DButtonsPosJsCallBack(
        "moduleMeshDeform.SetUpdate2DButtonsPosJsCallBack",
      )
      console.log("SetUpdate2DButtonsPosJsCallBack successfully")
    }
  }
  Set2DButtonsVisiblityJsCallBack(callback: (isShow: boolean) => void) {
    if (!wasmModule.isFinishedOpencase) return
    this.wasmdeformModule = wasmModule.moduleManager.GetMeshDeformModule()
    if (!(window as any).moduleMeshDeform) {
      ;(window as any).moduleMeshDeform = {}
    }
    ;(window as any).moduleMeshDeform.Set2DButtonsVisiblityJsCallBack = callback
    if (this.wasmdeformModule != null) {
      this.wasmdeformModule.Set2DButtonsVisiblityJsCallBack(
        "moduleMeshDeform.Set2DButtonsVisiblityJsCallBack",
      )
      console.log("Set2DButtonsVisiblityJsCallBack successfully")
    }
  }
}

export const meshdeformModel = new DeformModel()
